import { cn } from "@/lib/cn";

/**
 * Tarjeta/sección homologada (doc UX 20260627: "reducir bordes visibles,
 * incrementar padding interno, sombra muy ligera, homologar todas las
 * tarjetas"). Sustituye al patrón inline
 * `rounded-lg border bg-white p-4 shadow-sm`.
 *
 * Usa `title` para el encabezado estándar de sección (antes un `h2` uppercase
 * con borde inferior); el borde se sustituye por espacio en blanco y una línea
 * muy tenue para bajar el ruido visual.
 */
export function Card({
  title,
  actions,
  padding = "md",
  className,
  bodyClassName,
  children,
}: {
  title?: React.ReactNode;
  /** Acciones alineadas a la derecha del título. */
  actions?: React.ReactNode;
  padding?: "none" | "sm" | "md" | "lg";
  className?: string;
  bodyClassName?: string;
  children: React.ReactNode;
}) {
  const pad =
    padding === "none" ? "" : padding === "sm" ? "p-4" : padding === "lg" ? "p-6 sm:p-7" : "p-5 sm:p-6";
  return (
    <section
      className={cn(
        "rounded-xl border border-edge/70 bg-surface shadow-card transition-shadow",
        className,
      )}
    >
      {title && (
        <div className="flex items-center justify-between gap-3 px-5 pt-4 sm:px-6">
          <h2 className="text-sm font-semibold text-fg">{title}</h2>
          {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
        </div>
      )}
      <div className={cn(title ? "mt-3 border-t border-edge/60" : "", pad, bodyClassName)}>
        {children}
      </div>
    </section>
  );
}
